"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M21 18.5c0 1.3807-1.1193 2.5-2.5 2.5S16 19.8807 16 18.5s1.1193-2.5 2.5-2.5 2.5 1.1193 2.5 2.5z",
    fill: "#0A8A00"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 4.2038C11.3143 3.4634 10.3336 3 9.2447 3 7.1534 3 5.8203 5.1637 6.656 7H2v7h1v7h10v-7h9V7h-4.6556c.8357-1.8363-.4974-4-2.5887-4-1.0889 0-2.0695.4634-2.7555 1.2038zm-1 2.7962H8.9664l-.4394-.7324C8.1923 5.7097 8.594 5 9.2447 5c.9695 0 1.7555.786 1.7555 1.7555V7zm4.0338 0h-2.0338v-.2445c0-.9695.786-1.7555 1.7555-1.7555.6506 0 1.0525.7097.7177 1.2676L15.034 7zM20 12H4V9h16v3zM5 14v5h6v-5H5z"
  })];
};

exports.default = _default;